import { render, staticRenderFns } from "./homepage-trending-djs.vue?vue&type=template&id=5e9c7767&scoped=true"
import script from "./homepage-trending-djs.vue?vue&type=script&lang=js"
export * from "./homepage-trending-djs.vue?vue&type=script&lang=js"
import style0 from "./homepage-trending-djs.vue?vue&type=style&index=0&id=5e9c7767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c7767",
  null
  
)

export default component.exports